import { Grid } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Tarjeta_Paso, { TAMANO_CIRCULO } from "../../Tarjetas/Tarjeta_Paso";

const COLOR_FLECHA = "#1C3A5F";

const Lista_Pasos = ({ pasos = [] }) => {
    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            wrap="nowrap"
            size={{ xs: 12 }}
            sx={{
                flexDirection: { xs: "column", md: "row" },
                gap: { xs: 3, md: 0 },
                width: "100%",
            }}
        >
            {pasos.map((paso, index) => (
                <Grid
                    key={index}
                    container
                    justifyContent="center"
                    alignItems="center"
                    wrap="nowrap"
                    size={{ xs: 12, md: "auto" }}
                    sx={{
                        flexDirection: { xs: "column", md: "row" },
                        flex: { xs: "unset", md: "1 1 0" },
                        width: { xs: "100%", md: "auto" },
                        minWidth: 0,
                    }}
                >
                    <Grid
                        size={{ xs: 12, md: true }}
                        sx={{ width: "100%", minWidth: 0 }}
                    >
                        <Tarjeta_Paso
                            numero={paso.numero}
                            titulo={paso.titulo}
                            descripcion={paso.descripcion}
                            icono={paso.icono}
                        />
                    </Grid>

                    {index < pasos.length - 1 && (
                        <Grid
                            container
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                                height: { xs: "auto", md: TAMANO_CIRCULO },
                                width: { xs: "100%", md: "auto" },
                                px: { xs: 0, md: 2 },
                                py: { xs: 2, md: 0 },
                                flexShrink: 0,
                            }}
                        >
                            <ChevronRightIcon
                                sx={{ fontSize: 40, color: COLOR_FLECHA, display: { xs: "none", md: "block" } }}
                            />
                            <KeyboardArrowDownIcon
                                sx={{ fontSize: 32, color: COLOR_FLECHA, display: { xs: "block", md: "none" } }}
                            />
                        </Grid>
                    )}
                </Grid>
            ))}
        </Grid>
    );
};

export default Lista_Pasos;